module.exports = __webpack_public_path__ + "img/warning.0b257a26.svg";